import React, { useState } from 'react'
import styles from "./Sharedproject.module.css"


const Myproject = () => {
    const [projectlen, setProjectLen] = useState(0);

    return (
        <div className={styles.product_page_outer}>
            {projectlen === 0 ?
                <div className={styles.newproject}>
                    {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/newfileicon.svg"} alt='newfile' /> */}
                    <svg width="91" height="100" viewBox="0 0 91 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="66.4507" height="81.8191" rx="12" transform="matrix(0.938209 0.346069 0.338006 -0.941144 0.5 77.0039)" fill="var(--secondary-light)" />
                        <rect x="12.3281" y="9.02734" width="66.3458" height="81.9454" rx="12" fill="currentColor" />
                        <rect x="24.7695" y="59.4561" width="41.4661" height="6.30349" rx="3.15175" fill="white" />
                        <rect x="28.918" y="72.0625" width="33.1729" height="6.30349" rx="3.15175" fill="white" />
                        <g clip-path="url(#clip0_41_1967)">
                            <path d="M36.9485 27.676C38.0662 26.5142 39.4005 25.5889 40.8739 24.9537C42.3472 24.3185 43.9304 23.9861 45.5315 23.9758C47.1326 23.9656 48.7198 24.2776 50.201 24.8938C51.6822 25.51 53.0279 26.4181 54.1601 27.5655C55.2923 28.7129 56.1884 30.0767 56.7964 31.5778C57.4044 33.0789 57.7123 34.6874 57.7022 36.31C57.692 37.9327 57.3641 39.5371 56.7373 41.0303C56.1105 42.5234 55.1974 43.8756 54.051 45.0084C51.77 47.2411 48.715 48.4765 45.5439 48.4485C42.3728 48.4206 39.3394 47.1316 37.097 44.8591C34.8546 42.5866 33.5827 39.5124 33.5551 36.2987C33.5276 33.085 34.7466 29.9889 36.9497 27.6773L36.9485 27.676ZM46.7098 32.6658C46.7098 32.3407 46.5824 32.029 46.3555 31.7991C46.1287 31.5692 45.8211 31.4401 45.5004 31.4401C45.1796 31.4401 44.872 31.5692 44.6452 31.7991C44.4183 32.029 44.2909 32.3407 44.2909 32.6658V35.1171H41.8721C41.5513 35.1171 41.2437 35.2463 41.0169 35.4761C40.7901 35.706 40.6626 36.0178 40.6626 36.3428C40.6626 36.6679 40.7901 36.9797 41.0169 37.2095C41.2437 37.4394 41.5513 37.5685 41.8721 37.5685H44.2909V40.0199C44.2909 40.3449 44.4183 40.6567 44.6452 40.8866C44.872 41.1164 45.1796 41.2455 45.5004 41.2455C45.8211 41.2455 46.1287 41.1164 46.3555 40.8866C46.5824 40.6567 46.7098 40.3449 46.7098 40.0199V37.5685H49.1286C49.4494 37.5685 49.757 37.4394 49.9838 37.2095C50.2106 36.9797 50.3381 36.6679 50.3381 36.3428C50.3381 36.0178 50.2106 35.706 49.9838 35.4761C49.757 35.2463 49.4494 35.1171 49.1286 35.1171H46.7098V32.6658Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_41_1967">
                                <rect width="29.0263" height="29.4163" fill="white" transform="translate(30.9883 21.6348)" />
                            </clipPath>
                        </defs>
                    </svg>

                    <p className={styles.createtext}>
                        No shared projects are there
                    </p>
                </div> :
                <div className={styles.indivprojectouter}>
                    <div className={styles.project_heading}>
                        <p>Shared Projects</p>
                        {/* <button>+ New Project</button> */}
                    </div>
                    {/* <div className={styles.indivprojectlist}>
                        <div className={styles.indivproject}>
                            <h1>Project Title</h1>
                            <button>Go to editor</button>
                            <hr style={{ borderColor: "#CCCBD3", marginTop: "24px", borderWidth: "1px" }} />
                            <div className={styles.fileactionbtn}>
                                <button><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/edit.png"} alt='rename' /></button>
                                <button><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/settings.png"} alt='settings' /></button>
                                <button><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/delete.png"} alt='delete' /></button>
                            </div>
                        </div>

                    </div> */}
                </div>
            }

        </div>
    )
}

export default Myproject